<template>
  <div class="ds-icon-text-item">
    <picture class="ds-icon-text-item__icon-container">
      <source v-if="mobileIconSrc" media="(max-width: 599px)" :srcset="mobileIconSrc" />
      <img class="ds-icon-text-item__icon" :src="iconSrc" :style="iconStyle" alt="" aria-hidden="true" />
    </picture>

    <DsText as="body3" class="ds-icon-text-item__text">
      {{ text }}
    </DsText>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import DsText from '../atoms/DsText.vue'

const props = withDefaults(
  defineProps<{
    iconSrc: string
    mobileIconSrc?: string
    text: string
    iconWidth?: number
    iconHeight?: number
  }>(),
  {
    iconWidth: 40,
    iconHeight: 40
  }
)

const iconStyle = computed(() => ({
  width: `${props.iconWidth}px`,
  height: `${props.iconHeight}px`
}))
</script>

<style scoped>
.ds-icon-text-item {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  min-width: 0;
}

.ds-icon-text-item__icon-container {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 40px;
  width: 40px;
  height: 40px;
}

.ds-icon-text-item__icon {
  display: block;
  max-width: 40px;
  max-height: 40px;
  object-fit: contain;
}

.ds-icon-text-item__text {
  min-width: 0;
  color: var(--ds-text-primary);
  line-height: 24px;
}
</style>
